import React, { useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import './MainDesignersBrand.scss';
import PageTitle from '../../widgets/PageTitle/PageTitle';
import Marquee from 'react-fast-marquee';
import config from '../../config';
import { NavLink } from 'react-router-dom';
import { fireTealiumEvent } from '../../utils/Helper';

const MainDesignersBrand = (props) => {
  const { curLang, data, pageTitle } = props;

  const headerTitle = {
    sc: '设计师',
    en: 'DESIGNERS BRAND',
    tc: '設計師',
  };

  return (
    <section className="main-designersbrand">
      <PageTitle title={pageTitle} link={`${config.routePathTo}/${curLang}/designers`} />
      <Marquee speed={50} className="designersbrand-marquee">
        {data?.map((item, index) => (
          <div className="card-container" key={index}>
            <NavLink
              to={(location) => ({
                ...location,
                pathname: `${config.routePathTo}/${curLang}/designers/${item.topMetadata.designerId}`,
                search: `?p1=${item.topMetadata.brandName}&ref_source=fashionally_home_designer`,
              })}
            >
              <img src={item.designer?.thumbnail_upload} alt={`designer-image-${index}`} />
            </NavLink>
            <div className="ins-info-wrapper">
              <a
                href={item.designer?.instagram}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  fireTealiumEvent(
                    JSON.stringify({
                      event_action: 'click',
                      event_name: 'link_click',
                      event_title: `Fashionally : Designer Instagram (Home) - ${
                        item[curLang]?.designer_detail?.designer_name
                      } (${curLang?.toUpperCase()})`,
                      event_category: 'Designer (Home)',
                      event_click: '1',
                      site_url: '/virtual/fashionally/home.htm',
                      link_category: 'Designer',
                      link_name: `Designer Instagram (Home) - ${item[curLang]?.designer_detail?.designer_name}`,
                      link_url: item.designer?.instagram,
                    }),
                  );
                }}
              >
                <div className="inner-wrapper">
                  <div className="brand">{item[curLang]?.designer_detail?.brand_name}</div>
                  <div className="name">{item[curLang]?.designer_detail?.designer_name}</div>
                </div>
              </a>
            </div>
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default MainDesignersBrand;
